import { medicalAidDisplay } from 'src/app/core/utils/scheme-code';
import { environment } from 'src/environments/environment';
import { ChatService } from '../../../chat/chat.service';
import { WhatsAppChatDialogComponent } from './../../../shared/components/whatsapp-chat-dialog/whatsapp-chat-dialog.component';
import { PatientConsentService } from 'src/app/core/services/patient-consent.service';
import { IcdSuggestionService } from 'src/app/core/services/icd-suggestion.service';
import { IcdSuggestionsDialogComponent } from './icd-suggestions-dialog/icd-suggestions-dialog.component';
import { PatientReferralDialogComponent, PatientReferralDialogData, PatientReferralDialogResult } from './patient-referral-dialog/patient-referral-dialog.component';
import { referralsEnabledFor } from '../../../core/services/referral.service';
import { isStateModeGroup } from '../../../shared/util/state-mode.util';
import { ClinicalSummaryDialogComponent } from './clinical-summary-dialog/clinical-summary-dialog.component';
import { IcdArchivedCodesDialogComponent } from './icd-archived-codes-dialog/icd-archived-codes-dialog.component';
import { SpeechRecognitionService } from './../../../core/services/speech-recognition.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable, Subscription, filter, firstValueFrom, map, of, startWith, switchMap, takeUntil, tap, timer } from 'rxjs';
import { patientIdChanges } from './patient-route-id';
import { GroupService } from 'src/app/core/services/group.service';
import { PracticeSwitchService } from 'src/app/core/services/practice-switch.service';
import { PatientAiService } from 'src/app/core/services/patient-ai.service';
import { PatientAppLink, PatientService } from 'src/app/core/services/patient.service';
import { ScrollPositionService } from 'src/app/core/services/scroll-position.service';
import { BaseComponent } from './../../../core/components/base/base.component';
import { NETWORK_SPECIALITIES, TITLES } from './../../../core/data/app.data';
import { AiAssistantService } from './../../../core/services/ai-assistant.service';
import { AIService } from './../../../core/services/ai.service';
import { ColleagueService } from './../../../core/services/colleague.service';
import { FeedbackService } from './../../../core/services/feedback.service';
import { HospitalService } from './../../../core/services/hospital.service';
import { IdleService } from './../../../core/services/idle.service';
import { PatientNoteService } from './../../../core/services/patient-note.service';
import { PatientPrescriptionService } from './../../../core/services/patient-prescription.service';
import { ScreenWakeService } from './../../../core/services/screen-wake.service';
import { StateCacheService } from './../../../core/services/state-cache.service';
import { TagService } from './../../../core/services/tag.service';
import { AiDialogComponent } from './../../../shared/components/ai-dialog/ai-dialog.component';
import { AI_DIALOG_PANEL_CLASSES, AI_MODAL_PANEL_CLASSES, FLOATING_AI_DIALOG_BASE } from './../../../shared/config/floating-ai-dialog.config';
import { LinkPatientMedicalDetailsDialogComponent } from './link-patient-medical-details-dialog/link-patient-medical-details-dialog.component';
import { DisputeFormComponent } from './dispute-form/dispute-form.component';
import { PatientFormSendDialogComponent } from './patient-form-list/patient-form-send-dialog.component';
import { PatientDocumentSendDialogComponent } from './patient-document-list/patient-document-send-dialog.component';
import { UserService } from 'src/app/core/services/user.service';
import { AppDataService } from 'src/app/core/services/app-data.service';
import { runIcdRules } from 'src/app/core/engines/icd-rules-engine/icd-rules';
import { IcdChipView, icdChipView, orderIcdCodes, withIcdReference } from 'src/app/shared/util/icd-chip-state.util';
import { ageFromDob, sexFromPatient } from 'src/app/shared/util/icd-coding-context.util';
import { IcdCodeEditDialogComponent } from './icd-code-edit-dialog/icd-code-edit-dialog.component';
import { ExportProgressDialogComponent } from './../../../shared/components/export-progress-dialog/export-progress-dialog.component';
import { activeReferralLinkCount } from 'src/app/core/models/referral.model';
import { ReferralService } from 'src/app/core/services/referral.service';
import { parentListPath } from './patient-file-parent';
import { patientReportedLabel, withPatientReported } from 'src/app/core/utils/patient-reported';
import { PatientAuthorizationService } from 'src/app/core/services/patient-authorization.service';
import { authorisationLines } from 'src/app/core/utils/authorisation-summary';
import { CHAT_ACTION_PARAMS_CLEARED, chatActionPractice, chatActionRequest } from './chat-action-request';

@Component({
  selector: 'app-patient-file',
  templateUrl: './patient-file.component.html',
  styleUrls: ['./patient-file.component.scss']
})
export class PatientFileComponent extends BaseComponent implements OnInit, OnDestroy {
  readonly medicalAidDisplay = medicalAidDisplay;

  private subscriptions: Subscription[] = [];
  isMobile!: boolean;
  hasHospitals: boolean = true;
  aiIsBusy: boolean = true;
  /** Guards the header button between the click and the export dialog opening. */
  isExportingFile: boolean = false;

  // The `@ViewChild(PatientRiskListComponent) riskListSection` that used to sit here is GONE.
  //
  // It existed for deviation L-1: the risk-item `+` opened the shared add DIALOG through the
  // section component, because no add PAGE existed and building one would have meant a second copy
  // of the D7 taxonomy, the D8 evidence rules and the §4 facility preview. Workstream N built that
  // page (`add-risk-item` / `edit-risk-item/:id`), so `manageRiskItem` below now routes like every
  // sibling `+` and nothing else referenced the ViewChild.

  @ViewChild('tagInputElement') tagInputElement!: ElementRef<HTMLInputElement>;
  @ViewChild('auto') autocompleteTrigger!: MatAutocompleteTrigger;

  tagControl = new FormControl();
  filteredTags?: Observable<any[]>;
  patientTags: any[] = [];
  groupTags: any[] = [{ id: 1, tag: 'Tag 1' }, { id: 2, tag: 'Tag 2' }];
  readonly separatorKeysCodes: number[] = [13, 188]; // Enter and comma key codes
  /** The "Patient reported" mark on a summary chip the patient gave (their invite, or the patient app). */
  readonly reported = patientReportedLabel;
  readonly withReported = withPatientReported;
  addOnBlur = false;

  selectedGroup?: any;
  patient: any;

  titles = TITLES;
  specialities = NETWORK_SPECIALITIES;

  /**
   * Practice forms are BUILT AND HARNESSED but hidden from the UI (tasks/patient-forms.md §17).
   * Three entry points live in this file — the sidebar action, the accordion panel and the export
   * section toggle — and all three read this one flag. Nothing was deleted.
   */
  /**
   * Practice forms are BUILT AND HARNESSED but hidden from the UI (tasks/patient-forms.md §17).
   *
   * Read through a cast, deliberately. The real `environment.*.ts` files are GITIGNORED — only the
   * samples are tracked — so a deployer's existing `environment.prod.ts` will not carry this key
   * until someone adds it, and a direct property access would fail the strict build rather than
   * hide a feature. The cast makes a missing key mean `undefined`, and `=== true` makes `undefined`
   * mean HIDDEN. Fail-closed: the only way this feature appears is if someone deliberately sets it.
   */
  readonly practiceFormsEnabled =
    (environment as Record<string, unknown>)['PRACTICE_FORMS_ENABLED'] === true;

  private originalMenuOptions = [
    { text: 'Admit Patient', icon: 'login', action: () => this.navigate(undefined, 'admitPatient') },
    { text: 'Discharge Patient', icon: 'logout', action: () => this.navigate(undefined, 'dischargePatient') },
    { text: 'Add Tag', icon: 'tag', action: () => this.scrollTo('tags') },
    { text: 'Add M&M', icon: 'warning_amber', action: () => this.navigate(undefined, 'manageMorbidityMortality') },
    { text: 'Add Estimate/Invoice', icon: 'money', action: () => this.navigate(undefined, 'manageFinancials') },
    { text: 'Add Patient Consent', icon: 'assignment', action: () => this.navigate(undefined, 'manageConsent') },
    { text: 'Add Procedure Code', icon: 'money', action: () => this.navigate(undefined, 'manageCoding') },
    { text: 'Add Task', icon: 'task', action: () => this.navigate(undefined, 'manageTask') },
    { text: 'Add Risk Item', icon: 'report_problem', action: () => this.navigate(undefined, 'manageRiskItem') },
    { text: 'Add Appointment', icon: 'event', action: () => this.navigate(undefined, 'manageAppointment') },
    { text: 'Add Lab Order', icon: 'science', action: () => this.navigate(undefined, 'manageLabOrder') },
    { text: 'Add Prescription', icon: 'medication', action: () => this.navigate(undefined, 'managePrescription') },
    { text: 'Send Form', icon: 'assignment', action: () => this.navigate(undefined, 'manageForm') },
    // Practice documents (tasks/practice-documents.md 7 phase 2). Deliberately NOT filtered in
    // `updateMenuOptions` the way 'Send Form' is: forms are hidden behind PRACTICE_FORMS_ENABLED,
    // documents ship visible.
    { text: 'Send Document', icon: 'description', action: () => this.navigate(undefined, 'manageDocument') },
    { text: 'Add Clinical Note', icon: 'note_add', action: () => this.navigate(undefined, 'manageNote') },

  ]

  menuOptions: any[] = [];
  colleagues: any[] = [];

  defaultExpandedPanels: { [key: string]: boolean } = {
    timeline: true,
    ai_request: true,
    prescription: false,
    lab_orders: false,
    appointments: false,
    tasks: false,
    risk: false,
    billing: false,
    invoicing: false,
    consent: false,
    forms: false,
    documents: false,
    surveys: false,
    communication: false,
    media: false,
    tags: true
  };
  expandedPanels = { ...this.defaultExpandedPanels };

  activeMedication!: any[] | null;

  consentConditions: any = {};

  constructor(
    readonly chatService: ChatService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
    private patientService: PatientService,
    private patientNotesService: PatientNoteService,
    private scrollPositionService: ScrollPositionService,
    private tagService: TagService,
    private groupService: GroupService,
    private idleService: IdleService,
    private patientAIService: PatientAiService,
    private colleagueService: ColleagueService,
    private hospitalService: HospitalService,
    private stateCache: StateCacheService,
    private aiService: AIService,
    private screenWake: ScreenWakeService,
    private patientPrescriptionService: PatientPrescriptionService,
    private aiAssistantService: AiAssistantService,
    private speechRecognitionService: SpeechRecognitionService,
    private patientConsentService: PatientConsentService,
    private icdSuggestionService: IcdSuggestionService,
    private appDataService: AppDataService,
    private userService: UserService,
    private referralService: ReferralService,
    private authorizationService: PatientAuthorizationService,
    private practiceSwitch: PracticeSwitchService,
    @Inject(PLATFORM_ID) private platformId: Object,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);

    this.hospitalService.hospitals$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hospitals => {
        this.hasHospitals = hospitals?.length !== 0;
        this.updateMenuOptions();
      });

    this.breakpointObserver.observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape])
      .subscribe(result => {
        this.isMobile = result.matches;
      });

    this.groupService.selectedGroup$
      .subscribe(result => {
        this.selectedGroup = result;
        this.updateMenuOptions();
      });


    this.tagService.tags$
      .pipe(takeUntil(this.destroy$))
      .subscribe(tags => {
        this.groupTags = tags;
        this.filteredTags = this.tagControl.valueChanges.pipe(
          startWith(''),
          switchMap(value => this.filterTags(value))
        );
      });

    this.colleagueService.colleagues$
      .pipe(takeUntil(this.destroy$))
      .subscribe(colleagues => this.colleagues = colleagues);

    this.aiService.isProcessing
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.aiIsBusy = result;
      });

    this.patientPrescriptionService.patientMedication$
      .pipe(
        map((medication) => {
          return medication?.filter(((i: any) => i.active)) || [];
        }),
      ).subscribe({
        next: (medication) => {
          this.activeMedication = medication;
        },
        error: (err) => {
          this.activeMedication = [];
        }
      });

    this.patientConsentService.patientConsents$
      .pipe(takeUntil(this.destroy$))
      .subscribe(consents => {
        this.consentConditions = this.patientConsentService.analyzeConsentConditions(consents);
      });

    patientIdChanges(this.route.paramMap)
      .pipe(
        switchMap((patientId) => this.patientService.getPatientById(patientId, true)),
        takeUntil(this.destroy$)
      ).subscribe(); // Load the patient, again whenever the id in the URL changes

    // A chat action can arrive for the patient already open, when only the query changes.
    this.route.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(() => void this.openChatActionIfAsked());
  }

  get userRole(): string {
    return this.selectedGroup?.userRole;
  }

  /** Referrals to external clinicians (tasks/referrals.md §5.3), behind the fail-closed REFERRALS_ENABLED flag; never for a state unit. */
  get referralsEnabled(): boolean {
    return referralsEnabledFor(this.selectedGroup);
  }

  /** A state unit (tasks/state-mode.md): nothing that reaches outside the system is offered. */
  get stateMode(): boolean {
    return isStateModeGroup(this.selectedGroup);
  }

  /** Procedure codes: a state unit records ICD-10 codes only. */
  get showCoding(): boolean {
    return !this.stateMode;
  }

  /** Satisfaction surveys: a state unit sends none. */
  get showSurveys(): boolean {
    return !this.stateMode;
  }

  /** How many referral links are actively sharing THIS patient: the badge on the card's referral button. */
  activeReferralLinks = 0;
  /** The patient the count belongs to, so switching patients never shows the last one's number. */
  private countedReferralsFor: string | null = null;

  /** Admin or Physician may refer and stop sharing; everyone else who can open the dialog only sees the status. */
  get canRefer(): boolean {
    const role = this.selectedGroup?.userRole?.toLowerCase();
    return role === 'admin' || role === 'physician';
  }

  /** The patient app link of this file (tasks/patient-app.md §4.5): the "Linked to patient app" mark. */
  patientApp: PatientAppLink | null = null;
  private patientAppFor: string | null = null;

  /** The patient's authorisations, one line each, for the summary card. */
  authorisations: string[] = [];

  /** Loaded each time the patient is (re)loaded, so a number added in the patient's details shows on return. */
  loadAuthorisations(): void {
    const patientId = this.patient?.id;
    if (!patientId) {
      this.authorisations = [];
      return;
    }
    this.authorizationService.loadByPatient(patientId).pipe(takeUntil(this.destroy$)).subscribe({
      // The patient may have changed while this was in flight. A failure leaves the card without the list.
      next: (response) => {
        if (this.patient?.id === patientId) this.authorisations = authorisationLines(response?.data, response?.legacy);
      },
      error: () => { if (this.patient?.id === patientId) this.authorisations = []; },
    });
  }

  private loadPatientAppLink(): void {
    const patientId = this.patient?.id;
    if (!patientId) {
      this.patientApp = null;
      return;
    }
    if (this.patientAppFor === patientId) return;
    this.patientAppFor = patientId;
    this.patientApp = null;
    this.patientService.getPatientAppLink(patientId).pipe(takeUntil(this.destroy$)).subscribe({
      // The patient may have changed while this was in flight. A failure simply shows no mark.
      next: (link) => { if (this.patient?.id === patientId) this.patientApp = link; },
      error: () => { this.patientApp = null; },
    });
  }

  /** The practice ends the link (§5.3). Admins only; the server checks the role again. */
  async endPatientAppLink(): Promise<void> {
    const patientId = this.patient?.id;
    if (!patientId || !this.patientApp?.canEnd) return;
    const confirmed = await this.showConfirmationDialog(
      'End patient app link',
      'This file will no longer share consents with the patient\'s app. The patient keeps what they already received, and can link again from a new invite.',
      undefined, 'Cancel', 'End link',
    );
    if (!confirmed) return;
    this.patientService.endPatientAppLink(patientId).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.patientApp = this.patientApp ? { ...this.patientApp, linked: false, linkedAt: null, canEnd: false } : null;
        this.showToastMessage('Patient app link ended');
      },
      error: () => this.showToastMessage('Could not end the patient app link'),
    });
  }

  /**
   * Who is actively receiving THIS patient. Read from the same list the referral dialog shows, so the badge and the
   * dialog can never disagree; a failure leaves the badge off rather than showing a number nobody can trust.
   */
  private countActiveReferralLinks(): void {
    const patientId = this.patient?.id;
    if (!this.referralsEnabled || this.userRole === 'Support-Limited' || !patientId) return;
    if (this.countedReferralsFor === patientId) return;
    this.countedReferralsFor = patientId;
    this.activeReferralLinks = 0;
    this.referralService.listPatientReferrals(patientId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (referrals) => {
        // The patient may have changed while this was in flight.
        if (this.patient?.id === patientId) this.activeReferralLinks = activeReferralLinkCount(referrals);
      },
      error: () => { this.activeReferralLinks = 0; },
    });
  }

  openReferralDialog(event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (!this.patient?.id) return;
    this.dialog.open<PatientReferralDialogComponent, PatientReferralDialogData, PatientReferralDialogResult>(PatientReferralDialogComponent, {
      width: '720px',
      maxHeight: '90vh',
      data: {
        patientId: this.patient.id,
        patientName: `${this.patient?.name || ''} ${this.patient?.surname || ''}`.trim(),
        canRefer: this.canRefer,
      },
    })
      // Referring, or stopping, changes who receives this patient: the badge is counted again.
      .afterClosed().pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.countedReferralsFor = null;
        this.countActiveReferralLinks();
      });
  }

  /** Practice administrator of the currently selected group. Mirrors PatientListComponent. */
  get isGroupAdmin(): boolean {
    return this.selectedGroup?.userRole?.toLowerCase() === 'admin';
  }

  // ── Patient file export options ────────────────────────────────────────────
  //
  // What the export contains. Keys and their meaning are the server's
  // (`services/patientFileExportService.js` EXPORT_SECTIONS) — this list only decides the order
  // and wording the user sees. An absent key means "included", so a client that falls behind a
  // new server section keeps exporting it.
  readonly exportSections: { key: string; label: string }[] = [
    { key: 'clinicalNotes', label: 'Clinical notes' },
    { key: 'appointments', label: 'Appointments & admissions' },
    { key: 'medicalBackground', label: 'Medical background' },
    { key: 'prescriptions', label: 'Prescriptions' },
    { key: 'labOrders', label: 'Lab orders & results' },
    { key: 'consents', label: 'Consents' },
    // Practice forms are hidden from the UI (tasks/patient-forms.md §17). The toggle is withheld,
    // NOT the data: the comment above is the reason — an absent key means "included", so a
    // subject-access export still carries the forms section. Hiding the switch must never quietly
    // narrow what a patient receives.
    ...((environment as Record<string, unknown>)['PRACTICE_FORMS_ENABLED'] === true
        ? [{ key: 'forms', label: 'Practice forms' }]
        : []),
    { key: 'billing', label: 'Billing & payments' },
    { key: 'communications', label: 'Communications' },
    { key: 'tasks', label: 'Tasks' },
  ];

  exportOptions: { sections: { [key: string]: boolean }; includeAudio: boolean } = {
    sections: {},
    includeAudio: false,
  };

  private readonly EXPORT_OPTIONS_KEY = 'patientFileExportOptions';

  /**
   * May this user have the audio? Practice admin is not enough — recordings are a separate
   * permission, and the server refuses `includeAudio` without it. Hiding the toggle explains
   * that decision; `resolveExportOptions` on the server is what makes it.
   */
  get canIncludeRecordings(): boolean {
    return this.selectedGroup?.canDownloadRecordings !== false;
  }

  get selectedExportSectionCount(): number {
    return this.exportSections.filter(s => this.exportOptions.sections[s.key] !== false).length;
  }

  /** Nothing to export but the patient record itself — the one selection worth refusing. */
  get hasNoExportSelection(): boolean {
    return this.selectedExportSectionCount === 0 && !this.exportOptions.includeAudio;
  }

  private loadExportOptions(): void {
    const sections: { [key: string]: boolean } = {};
    this.exportSections.forEach(s => { sections[s.key] = true; });
    this.exportOptions = { sections, includeAudio: false };

    try {
      const raw = localStorage.getItem(this.EXPORT_OPTIONS_KEY);
      if (!raw) return;
      const saved = JSON.parse(raw);
      if (saved?.sections) {
        // Only copy keys we know about, so a stale entry cannot resurrect a removed section.
        this.exportSections.forEach(s => {
          if (saved.sections[s.key] === false) this.exportOptions.sections[s.key] = false;
        });
      }
      // Audio is remembered, but never restored for someone who may not have it.
      this.exportOptions.includeAudio = saved?.includeAudio === true && this.canIncludeRecordings;
    } catch {
      // A corrupt or unavailable store just means defaults.
    }
  }

  private saveExportOptions(): void {
    try {
      localStorage.setItem(this.EXPORT_OPTIONS_KEY, JSON.stringify(this.exportOptions));
    } catch {
      // Private browsing or a full quota: the choice simply is not remembered.
    }
  }

  toggleExportSection(key: string, checked: boolean): void {
    this.exportOptions.sections[key] = checked;
    this.saveExportOptions();
  }

  toggleExportAudio(checked: boolean): void {
    this.exportOptions.includeAudio = checked;
    this.saveExportOptions();
  }

  setAllExportSections(checked: boolean): void {
    this.exportSections.forEach(s => { this.exportOptions.sections[s.key] = checked; });
    this.saveExportOptions();
  }

  /**
   * Opens the full-file export for this patient — the multi-sheet workbook plus every attached
   * media file, zipped.
   *
   * ⚠ ASKS WHAT ALREADY EXISTS FIRST. The build takes minutes and can run to hundreds of
   * megabytes, so pressing the button must never blindly start another one. If an export is
   * already running we reattach to it; if a finished one is still downloadable we offer that.
   * Only when there is neither do we queue new work. (The server enforces the same rule, so a
   * second tab or a second admin cannot double-queue either.)
   */
  exportPatientFile(): void {
    if (!this.patient || this.isExportingFile) return;

    this.isExportingFile = true;

    this.patientService.getCurrentPatientFileExport(this.patient.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (existing) => {
          if (existing) {
            this.isExportingFile = false;

            // ⚠ AN EXISTING EXPORT MAY NOT BE THE ONE THEY JUST ASKED FOR. Handing over a zip
            // built to a different selection — no audio when they ticked audio, or missing a
            // section — would look like the feature ignoring them, and they would have no way
            // to tell. Say what the existing one holds and let them choose.
            if (this.exportSelectionDiffers(existing.options)) {
              const useExisting = await this.showConfirmationDialog(
                'An export already exists',
                `This patient already has an export that ${this.describeExportOptions(existing.options)}. `
                + 'That is not what you selected. You can open the existing one, or build a new export '
                + 'with your selection.',
                [],
                'Build new export',
                'Open existing',
              );
              if (useExisting) {
                this.openExportDialog(existing.exportId);
              } else {
                this.isExportingFile = true;
                this.queuePatientFileExport();
              }
              return;
            }

            this.openExportDialog(existing.exportId);
            return;
          }
          this.queuePatientFileExport();
        },
        // A failed lookup should not block the export — fall through and queue one.
        error: () => this.queuePatientFileExport()
      });
  }

  /** True when a stored export's selection is not the one currently chosen. */
  private exportSelectionDiffers(stored: any): boolean {
    if (!stored) return false;
    if ((stored.includeAudio === true) !== this.exportOptions.includeAudio) return true;
    const storedSections = stored.sections || {};
    return this.exportSections.some(s =>
      (storedSections[s.key] !== false) !== (this.exportOptions.sections[s.key] !== false));
  }

  /** Plain-language summary of what an export holds, for the reuse prompt. */
  private describeExportOptions(stored: any): string {
    const sections = stored?.sections || {};
    const excluded = this.exportSections.filter(s => sections[s.key] === false).map(s => s.label);
    const audio = stored?.includeAudio === true ? 'includes audio recordings' : 'has no audio recordings';
    if (excluded.length === 0) return `covers every section and ${audio}`;
    return `leaves out ${excluded.join(', ').toLowerCase()} and ${audio}`;
  }

  private queuePatientFileExport(): void {
    this.patientService.startPatientFileExport(this.patient.id, this.exportOptions)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ exportId }) => {
          this.isExportingFile = false;
          this.openExportDialog(exportId);
        },
        error: (error) => {
          this.isExportingFile = false;
          console.error('Error starting patient file export:', error);
          this.showToastMessage(
            error?.error?.message || 'There was an error starting the export. Please try again.'
          );
        }
      });
  }

  private openExportDialog(exportId: string): void {
    const dialogRef = this.dialog.open(ExportProgressDialogComponent, {
      data: {
        patientId: this.patient.id,
        exportId,
        patientName: `${this.patient.title || ''} ${this.patient.name || ''} ${this.patient.surname || ''}`.trim(),
      },
      width: '480px',
      maxWidth: '95vw',
    });

    // "Generate a new export" from inside the dialog closes it and queues a fresh build.
    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result?.regenerate) {
          this.isExportingFile = true;
          this.queuePatientFileExport();
        }
      });
  }

  // ── ICD-10 coding suggestions (tasks/icd10-suggestion-pipeline.md §11) ──────────────

  /**
   * The chips rendered on the top card, ordered and with their states resolved.
   *
   * ⚠ BUILT ONCE PER PATIENT LOAD, NEVER FROM THE TEMPLATE. The enrichment behind it is
   * `performDirectLookup`, a linear `Array.find` over the whole ICD-10 codebook
   * (`app-data.service.ts:381`). Called from a binding it would run once per chip per
   * change-detection cycle — a full scan of tens of thousands of rows, several times a chip,
   * on every mouse move over the file.
   */
  icdChips: { code: any; view: IcdChipView }[] = [];

  /**
   * Joins each of the patient's codes to the codebook, runs the coding rules over the set, and
   * resolves the shared chip states.
   *
   * Until now the card showed the code and nothing else: a code that the picker would flag as a
   * category heading, withdrawn, sex-restricted or invalid as primary looked identical here to a
   * clean one. The file is where a clinician actually reads the coding, so it was the one screen
   * where the flags never appeared.
   *
   * Silent on failure for the same reason `loadIcdSuggestionCount` is — this is a decoration on
   * a screen whose real job is the patient record, and it must never be able to break it.
   */
  private buildIcdChips(): void {
    try {
      const ordered = orderIcdCodes(this.patient?.icdCodes || []);
      const enriched = ordered.map((chip: any) =>
        withIcdReference(chip, this.appDataService.performDirectLookup(chip.code, 'icd')));

      const { findings } = runIcdRules(enriched, {
        sex: sexFromPatient(this.patient),
        age: ageFromDob(this.patient?.dob),
      });

      this.icdChips = enriched.map((code: any, index: number) => ({
        code,
        view: icdChipView(code, index, findings.filter(f => f.codeIndex === index)),
      }));
    } catch {
      // Fall back to unenriched chips rather than an empty list: showing the codes with no
      // states is degraded, showing nothing is a clinician believing the patient has none.
      this.icdChips = orderIcdCodes(this.patient?.icdCodes || [])
        .map((code: any, index: number) => ({ code, view: icdChipView(code, index, []) }));
    }
  }

  /** Drives the badge beside the ICD-10 Codes heading. 0 hides it entirely. */
  icdPendingCount = 0;

  /**
   * Whether this patient has a standing clinical summary (§11.14), and when it was written.
   *
   * The count comes from a plaintext column, so asking this question does not decrypt anything —
   * which is why the icon can be driven off it rather than off the summary itself.
   */
  icdSummaryCount = 0;
  icdSummaryGeneratedAt: string | null = null;

  /**
   * The codes this patient no longer carries, and how many.
   *
   * The ROWS are held, not just the count. Removals are bounded per patient and the response is
   * already authorised, so one request drives both the icon and the dialog — which then opens with
   * no spinner and no second load path to keep in step with this one.
   */
  icdArchivedCodes: any[] = [];
  icdArchivedCount = 0;

  // ── The manual coding run (§11) ────────────────────────────────────────────────────

  /** `idle` | `queued` | `running` — what the pipeline is doing for this patient. */
  icdRunState: 'idle' | 'queued' | 'running' = 'idle';
  /** The batch stage while running (`extract` / `review` / `verify`), for the tooltip. */
  icdRunStage: string | null = null;
  /** Guards the button between the click and the server answering. */
  isTriggeringIcdRun = false;
  private icdRunPollSub?: Subscription;

  /** How often the status is re-read while a run is in flight. */
  private readonly ICD_RUN_POLL_MS = 30000;

  /**
   * Whether the "run the coding pipeline" button is offered at all.
   *
   * Three conditions, and each hides a different kind of nonsense:
   *
   *  - the practice has opted in (§10). Read from the group the same way
   *    `billing-view.component.ts` does; a group that never enabled coding has no pipeline to
   *    run and the server would refuse anyway.
   *  - the user is not `Support-Limited`. That role is excluded from every AI action on this
   *    screen already — the assistant, the AI dialog, the request detail — and this one spends
   *    the practice's balance, so it is the last place to make an exception.
   *  - there is a patient loaded.
   *
   * ⚠ This is a courtesy, not the guard. `POST /patients/:id/icd-run` establishes membership and
   * role from the database itself, because the route's `groupAuthMiddleware` currently returns
   * `next()` before any of its checks run. Hiding a button is not authorisation.
   */
  get canRunIcdPipeline(): boolean {
    return !!this.patient?.id
      && this.selectedGroup?.icdSuggestionsEnabled === true
      && this.userRole !== 'Support-Limited';
  }

  /** True while the pipeline is working on this patient — the button is disabled and spinning. */
  get icdRunInFlight(): boolean {
    return this.isTriggeringIcdRun || this.icdRunState !== 'idle';
  }

  /**
   * What the button says on hover.
   *
   * Names the STAGE while running, because the honest answer to "is this doing anything?" for a
   * job that can take hours is "yes, and here is where it is" — a spinner alone reads as stuck.
   */
  get icdRunTooltip(): string {
    if (this.isTriggeringIcdRun) return 'Queueing a coding review…';
    if (this.icdRunState === 'queued') return 'A coding review is queued for this patient';
    if (this.icdRunState === 'running') {
      const stage = this.icdRunStage === 'extract' ? 'reading the notes'
        : this.icdRunStage === 'review' ? 'reviewing the codes'
          : this.icdRunStage === 'verify' ? 'verifying the suggestions'
            : 'in progress';
      return `A coding review is running for this patient — ${stage}`;
    }
    return 'Run the AI coding review for this patient';
  }

  /**
   * Reads the current run state, and keeps reading while one is in flight.
   *
   * Silent on failure, like every other load on this screen: the button falls back to enabled,
   * and the 409 on the trigger is what actually prevents a double run.
   */
  private loadIcdRunStatus(): void {
    this.icdRunPollSub?.unsubscribe();
    this.icdRunPollSub = undefined;

    if (!this.canRunIcdPipeline) {
      this.icdRunState = 'idle';
      this.icdRunStage = null;
      return;
    }

    const patientId = this.patient.id;
    this.icdSuggestionService.getRunStatus(patientId).subscribe(
      (response) => {
        if (this.patient?.id !== patientId) return;
        this.applyIcdRunState(response?.data);
      },
      () => { this.icdRunState = 'idle'; this.icdRunStage = null; }
    );
  }

  /**
   * Applies a status response and starts or stops the poll to match.
   *
   * ⚠ THE REFETCH ON THE TRANSITION TO `idle` IS THE POINT OF THE POLL. A completed run is how
   * suggestions arrive, and nothing else on this screen would notice: auto-accepted CODES arrive
   * over the `patientIcdCodesUpdated` socket, but a pending SUGGESTION has no such event, so
   * without this the review badge would not appear until the file was reloaded — which, for
   * someone who has just sat waiting for the run they started, looks exactly like it failed.
   */
  private applyIcdRunState(data: any): void {
    const next = (data?.state === 'queued' || data?.state === 'running') ? data.state : 'idle';
    const was = this.icdRunState;

    this.icdRunState = next;
    this.icdRunStage = data?.stage || null;

    if (next === 'idle') {
      this.icdRunPollSub?.unsubscribe();
      this.icdRunPollSub = undefined;
      if (was !== 'idle') this.loadIcdSuggestionCount();
      return;
    }

    this.startIcdRunPoll();
  }

  /** One poll at a time, cancelled on destroy and on navigating to another patient. */
  private startIcdRunPoll(): void {
    if (this.icdRunPollSub) return;

    const patientId = this.patient?.id;
    if (!patientId) return;

    this.icdRunPollSub = timer(this.ICD_RUN_POLL_MS, this.ICD_RUN_POLL_MS)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => this.icdSuggestionService.getRunStatus(patientId)),
      )
      .subscribe(
        (response: any) => {
          // The poll outlives a navigation by one tick in the worst case; applying a stale
          // patient's state here would show one patient's run on another's file.
          if (this.patient?.id !== patientId) {
            this.icdRunPollSub?.unsubscribe();
            this.icdRunPollSub = undefined;
            return;
          }
          this.applyIcdRunState(response?.data);
        },
        // A failed poll stops the poll rather than retrying forever; the state is refreshed on
        // the next patient emission anyway.
        () => { this.icdRunPollSub = undefined; }
      );
  }

  /**
   * Queues a whole-record coding review for this patient, after confirming.
   *
   * ⚠ THE CONFIRMATION IS NOT A FORMALITY. This debits the group's AI balance and can trigger
   * auto-recharge, and a whole-record run is several times an ordinary night's extraction for
   * that patient (§11.3 measured 755 notes over 92 days against 2,843 over 400 on the live
   * group). It is paid once — facts cache by content hash forever (§8.3), so a later re-run
   * costs almost nothing — but the first one is a real charge and the copy says so.
   *
   * It also says the results arrive LATER. Both stages are OpenAI batch jobs polled every five
   * minutes; there is no version of this that returns suggestions while the user waits, and a
   * button that implied otherwise would be read as broken within a minute.
   */
  async runIcdPipeline(event?: MouseEvent): Promise<void> {
    event?.preventDefault();
    event?.stopPropagation();

    if (!this.canRunIcdPipeline || this.icdRunInFlight) return;

    const confirmed = await this.showConfirmationDialog(
      'Run AI Coding Review',
      'This reads this patient\'s ENTIRE record and proposes ICD-10 coding changes for your review. '
      + 'It uses your practice\'s AI balance, and the suggestions arrive in the background — usually '
      + 'within a few hours, not immediately. You can carry on working while it runs. Continue?',
      [],
      'Cancel',
      'Run Review',
    );
    if (!confirmed) return;

    const patientId = this.patient.id;
    this.isTriggeringIcdRun = true;

    this.icdSuggestionService.triggerRun(patientId).subscribe(
      (response: any) => {
        this.isTriggeringIcdRun = false;
        if (this.patient?.id !== patientId) return;
        this.showToastMessage(response?.message
          || 'Coding review queued. Suggestions will appear on this file once it completes.');
        // Optimistic, then corrected by the poll: the mark is written by the queue worker a
        // moment after this returns, so an immediate re-read can still legitimately say `idle`
        // and would flick the button back on for one cycle.
        this.applyIcdRunState({ state: 'queued', stage: null });
      },
      (error: any) => {
        this.isTriggeringIcdRun = false;
        if (this.patient?.id !== patientId) return;
        // 409 is not an error the user caused — someone (possibly they, in another tab) already
        // started it. Report it as the state it is, and let the poll take over.
        if (error?.status === 409) {
          this.showToastMessage(error?.error?.message
            || 'A coding review is already in progress for this patient');
          this.applyIcdRunState(error?.error?.data || { state: 'queued', stage: null });
          return;
        }
        this.showToastMessage(error?.error?.message || 'Could not queue the coding review');
      }
    );
  }

  /**
   * Loads the pending count for the badge.
   *
   * Silent on failure: a practice that has not enabled the feature has no suggestions and no
   * reason to see an error, and this is a decoration on a screen whose real job is the patient
   * record. It must never be able to break the patient file.
   */
  loadIcdSuggestionCount(): void {
    if (!this.patient?.id) {
      this.icdPendingCount = 0;
      return;
    }
    const patientId = this.patient.id;
    this.icdSuggestionService.getForPatient(patientId).subscribe(
      (response) => {
        // Guard against a slow response for a patient the user has already navigated away from.
        if (this.patient?.id !== patientId) return;
        this.icdPendingCount = response?.counts?.total || 0;
      },
      () => { this.icdPendingCount = 0; }
    );

    this.loadClinicalSummaryState(patientId);
    this.loadArchivedIcdCodes(patientId);
  }

  /**
   * Loads the codes that have been removed from this patient's record.
   *
   * Silent on failure for the same reason as the two loads above it. Called from here rather than
   * from its own lifecycle hook so it refreshes on the same trigger everything else does: every
   * patient emission runs `loadIcdSuggestionCount`, and both the edit dialog and the suggestions
   * dialog refetch the patient when something changed — so removing a code makes the icon appear
   * without a reload.
   */
  private loadArchivedIcdCodes(patientId: string): void {
    this.icdSuggestionService.getArchivedCodes(patientId).subscribe(
      (response) => {
        if (this.patient?.id !== patientId) return;
        this.icdArchivedCodes = response?.data || [];
        this.icdArchivedCount = this.icdArchivedCodes.length;
      },
      () => { this.icdArchivedCodes = []; this.icdArchivedCount = 0; }
    );
  }

  /**
   * The patient's previously used codes. Read-only — nothing here writes, so no refetch on close.
   */
  openIcdArchiveDialog(event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();

    this.dialog.open(IcdArchivedCodesDialogComponent, {
      width: '680px',
      data: {
        patientName: `${this.patient?.name || ''} ${this.patient?.surname || ''}`.trim(),
        codes: this.icdArchivedCodes,
      },
    });
  }

  /**
   * Loads just enough to decide whether the summary icon appears.
   *
   * Silent on failure for the same reason as the count above: a practice that has never run the
   * pipeline has no summary and no reason to see an error on a screen whose real job is the
   * patient record.
   */
  private loadClinicalSummaryState(patientId: string): void {
    this.icdSuggestionService.getClinicalSummary(patientId).subscribe(
      (response) => {
        if (this.patient?.id !== patientId) return;
        this.icdSummaryCount = response?.summary?.pointCount || 0;
        this.icdSummaryGeneratedAt = response?.summary?.generatedAt || null;
      },
      () => { this.icdSummaryCount = 0; this.icdSummaryGeneratedAt = null; }
    );
  }

  /** Opens the standing clinical summary. Read-only — nothing here changes the record. */
  openClinicalSummaryDialog(event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();

    this.dialog.open(ClinicalSummaryDialogComponent, {
      width: '620px',
      panelClass: AI_MODAL_PANEL_CLASSES,
      data: {
        patientId: this.patient?.id,
        patientName: `${this.patient?.name || ''} ${this.patient?.surname || ''}`.trim(),
      },
    });
  }

  openIcdSuggestionsDialog(event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();

    const dialogRef = this.dialog.open(IcdSuggestionsDialogComponent, {
      width: '720px',
      panelClass: AI_MODAL_PANEL_CLASSES,
      data: {
        patientId: this.patient?.id,
        patientName: `${this.patient?.name || ''} ${this.patient?.surname || ''}`.trim(),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Only refetch when something actually changed — accepting writes a code, and rejecting
      // can clear a removal flag, so the chips and the badge must move together.
      if (result?.changed) {
        this.patientService.getPatientById(this.patient.id, true).subscribe();
        this.loadIcdSuggestionCount();
      }
    });
  }

  /**
   * Whether the pencil beside the ICD-10 Codes heading is offered.
   *
   * Deliberately the SAME condition as reaching the codes through `managePatient`: the dialog is
   * a shortcut to a capability the user already has, not a new one. A tighter rule here would
   * hide the pencil from someone who can still edit the identical field two clicks away, which
   * reads as a bug; a looser one would be a genuine privilege escalation.
   *
   * ⚠ THAT CONDITION IS CURRENTLY "ANYONE WHO CAN SEE THE FILE". The `Review Record` buttons in
   * the validation banners call `navigate('managePatient')` with no role check, so `Support-
   * Limited` — which IS excluded from every AI action on this screen — can already edit the
   * codes through the full form. This getter matches that rather than inventing a stricter rule
   * for the shortcut alone. If the intent is that support should not touch coding, the fix
   * belongs on `managePatient` as well, and this becomes the one place to change.
   */
  get canEditIcdCodes(): boolean {
    return !!this.patient?.id;
  }

  /**
   * Edits the codes in place, rather than sending the clinician through the full patient form.
   *
   * Refetches on close for the same reason `openIcdSuggestionsDialog` does: a save can add,
   * remove and reorder codes at once, and the chips, their ordering and the suggestion badge
   * have to move together or the card contradicts itself.
   */
  openIcdCodeEditDialog(event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (!this.patient?.id || !this.canEditIcdCodes) return;

    const dialogRef = this.dialog.open(IcdCodeEditDialogComponent, {
      width: '760px',
      // The picker writes nothing until Save, but a stray backdrop click after reordering six
      // codes loses work that looks saved.
      disableClose: true,
      data: { patient: this.patient },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.changed) {
        this.patientService.getPatientById(this.patient.id, true).subscribe();
        this.loadIcdSuggestionCount();
      }
    });
  }

  /**
   * The coding history for one code, opened from an AI-applied or flagged chip.
   *
   * Only those chips are clickable: a code the practice typed in itself has no AI history worth
   * a dialog, and making every chip open one would train people to ignore it.
   */
  openIcdCodeHistory(code: any, event?: MouseEvent): void {
    if (!code || (code.source !== 'ai-auto' && !code.flaggedForRemoval)) return;
    event?.preventDefault();
    event?.stopPropagation();

    this.dialog.open(IcdSuggestionsDialogComponent, {
      width: '620px',
      panelClass: AI_MODAL_PANEL_CLASSES,
      data: {
        patientId: this.patient?.id,
        patientName: `${this.patient?.name || ''} ${this.patient?.surname || ''}`.trim(),
        code: code.code,
      },
    });
  }



  ngOnInit(): void {
    this.expandedPanels = { ...this.defaultExpandedPanels };
    this.loadExportOptions();



    this.patientService.currentPatient$
      .pipe(takeUntil(this.destroy$),)
      .subscribe(patient => {
        if (patient?.weight && patient?.height) {
          patient.bmi = this.calculateBMI(patient);
        }
        this.patient = patient;
        this.patientTags = this.patient?.tags;
        this.countActiveReferralLinks();
        this.loadPatientAppLink();
        this.loadAuthorisations();
        this.buildIcdChips();
        this.loadIcdSuggestionCount();
        this.loadIcdRunStatus();

        this.updateMenuOptions();
        this.openLinkDetailsIfAsked();
        void this.openChatActionIfAsked();

        console.log('### PatientChanged: ' + this.patientService.patientChanged);
        if (this.patient && this.patientService.patientChanged) {
          this.scrollTo('details', true);
          this.scrollPositionService.clearPosition('patientFile');
        } else {
          const cachedExpanedPanels = this.stateCache.get<any>('expandedPanels');
          this.expandedPanels = cachedExpanedPanels ?? this.expandedPanels;
          this.scrollPositionService.restoreScrollPosition('patientFile', 'details');
        }

        /* HIDDEN FINANCIAL */
        /*  if (this.patient && !this.userService.user?.suppressConsent) {
           this.checkMedicalAidDetails(false);
         } */


      });



    this.patientService.triggerAiRecording
      .pipe(takeUntil(this.destroy$))
      .subscribe(shouldTrigger => {
        if (shouldTrigger) {
          console.log('AI recording triggered from patient file component');
          this.openAIDialog(true);
        }
      });

    // Subscribe to detected commands from speech recognition
    this.subscriptions.push(
      this.speechRecognitionService.getDetectedCommand().subscribe((commandData) => {
        this.handleVoiceCommand(commandData.command, commandData.payload);
      })
    );

    // Listen for custom scroll to appointments event
    this.subscriptions.push(
      new Observable<void>(observer => {
        const handler = () => observer.next();
        window.addEventListener('scrollToAppointments', handler);
        return () => window.removeEventListener('scrollToAppointments', handler);
      }).subscribe(() => {
        this.scrollTo('appointments');
      })
    );


  }

  private handleVoiceCommand(command: string, payload?: any): void {
    switch (command) {
      case 'OPEN_RECORDING':
        console.log('Opening recording...');
        this.openAIDialog();
        break;
      case 'OPEN_CURA':
        console.log('Opening Cura...');
        this.openAssistantDialog();
        break;
      case 'CLOSE_FILE':
        console.log('Closing patient file...');
        this.returnToParent();
        break;
      case 'SCROLL_TO':
        console.log('scroll to section:', payload);
        // `payload` here is expected to be the matched section `id` provided by `SpeechRecognitionService`
        if (payload) {
          this.scrollTo(payload); // Scroll to the identified section
        } else {
          console.warn('No matching section found for scrolling.');
        }
        break;
    }
  }

  private calculateBMI(px: any) {
    const weight = px.weight;
    const height = px.height / 100; // Convert height from cm to meters
    let BMI;
    if (weight && height) {
      BMI = (weight / (height * height)).toFixed(2).toString();
    } else {
      BMI = null;
    }
    return BMI;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.scrollPositionService.saveScrollPosition('patientFile', 'details');
    this.stateCache.set('expandedPanels', this.expandedPanels);
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    // Held outside `subscriptions` because it is replaced on every patient emission rather than
    // accumulated — pushing each new poll onto that array would leak one subscription per
    // patient viewed. `takeUntil(destroy$)` covers it too; this is the explicit half.
    this.icdRunPollSub?.unsubscribe();
  }

  /**
   * The Connect page's "Link details" opens the file with ?linkDetails=1: once the patient in the URL has loaded,
   * open the dialog that links the medical aid, and drop the request from the URL so it opens once.
   */
  private openLinkDetailsIfAsked(): void {
    const snapshot = this.route.snapshot;
    if (!snapshot.queryParamMap.get('linkDetails') || !this.patient || this.patient.id !== snapshot.paramMap.get('id')) return;
    void this.router.navigate([], { relativeTo: this.route, queryParams: { linkDetails: null }, queryParamsHandling: 'merge', replaceUrl: true });
    this.dialog.open(LinkPatientMedicalDetailsDialogComponent, { data: { forceDetails: false } });
  }

  /**
   * A chat action (`/task` in a conversation) opens the file with ?action=add-task&text=…: once the patient in the URL
   * has loaded, drop the request from the file's URL (so Back returns to the plain file) and open the page with the rest.
   */
  private async openChatActionIfAsked(): Promise<void> {
    const snapshot = this.route.snapshot;
    const request = chatActionRequest(snapshot.queryParamMap);
    if (!request) return;
    // The page must run in the conversation's practice, not whichever one was selected last.
    // On a fresh load the practices arrive after the file opens, so wait for them when a practice is named.
    const groups = request.practice ? await firstValueFrom(this.groupService.userGroups$.pipe(filter((g) => !!g))) : null;
    const where = chatActionPractice(request.practice, this.groupService.group?.id, groups);
    if (where !== 'here') {
      if (this.switchingPractice) return;
      if (where === 'not-member') return this.dropChatAction("This chat belongs to a practice you are not a member of, so it can't be opened here.");
      this.switchingPractice = true;
      // The switch closes this file, so open the same link again once the practice has changed.
      const url = this.router.url;
      if (!(await this.practiceSwitch.switchTo(where.switchTo))) {
        this.switchingPractice = false;
        return this.dropChatAction('Stop the recording first: this chat belongs to another practice.');
      }
      await this.router.navigateByUrl(url);
      return;
    }
    if (!this.patient || this.patient.id !== snapshot.paramMap.get('id')) return;
    await this.router.navigate([], { relativeTo: this.route, queryParams: CHAT_ACTION_PARAMS_CLEARED, queryParamsHandling: 'merge', replaceUrl: true });
    // A note opened earlier would otherwise be the one the page edits.
    if (request.path[0] === 'add-note') this.patientNotesService.setEditingNote(null);
    await this.router.navigate(['/patients', { outlets: { patient: request.path } }], { queryParams: request.queryParams });
  }

  /** Set while switching to a chat's practice, so the second check (query or patient loaded) does not switch again. */
  private switchingPractice = false;

  /** Drops a chat's request from the URL without running it, and says why. */
  private async dropChatAction(message: string): Promise<void> {
    await this.router.navigate([], { relativeTo: this.route, queryParams: CHAT_ACTION_PARAMS_CLEARED, queryParamsHandling: 'merge', replaceUrl: true });
    this.feedbackService.showToast(message);
  }

  private checkMedicalAidDetails(forceDetails: boolean = false): Promise<boolean> {
    return new Promise((resolve, reject) => {

      if ((this.patient.status !== 'invite' && this.patient.medicalSchemeCode && this.patient.medicalPlanCode) || this.patient.medicalAid === 'Private Patient') {
        resolve(true);
        return;
      }


      const dialogRef = this.dialog.open(LinkPatientMedicalDetailsDialogComponent, { disableClose: forceDetails, data: { forceDetails } })
      const sub = dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          resolve(!!result)
          sub.unsubscribe();
        });


    });

  }

  openAssistantDialog() {
    this.aiAssistantService.openChat(this.patient.id);
  }

  isExpanded(panelId: string): boolean {
    return this.expandedPanels[panelId];
  }

  togglePanel(panelId: string, expanded: boolean): void {
    this.expandedPanels[panelId] = expanded;
  }

  private filterTags(value: string): Observable<any[]> {
    if (!value || typeof value !== 'string') return of(this.groupTags || []);
    const filterValue = value.toLowerCase();
    return of(this.groupTags).pipe(
      map(tags => tags.filter(tag =>
        tag.toLowerCase().includes(filterValue)
      ))
    );
  }

  private resetTagInput(): void {
    setTimeout(() => {
      this.tagInputElement.nativeElement.value = '';
      this.tagControl.reset();
    });
  }

  getDiagnosisArray(patient: any): string[] {
    const diagnosisArray = [];
    for (let i = 2; i <= 24; i++) {
      const fieldName = `diagnosis${i}`;
      if (patient[fieldName]) {
        diagnosisArray.push(patient[fieldName]);
      }
    }
    return diagnosisArray;
  }

  updateTagsSub?: Subscription;
  addTag(tag: any): void {
    this.scrollPositionService.saveScrollPosition('patientFile', 'details');
    const value = tag.tag || tag;
    if (!value) return;

    // Check if the tag already exists in patientTags
    const existingTag = this.patientTags.find(t => t.tag === value);

    if (!existingTag) {
      // If the tag doesn't exist in patientTags, add it
      this.patientTags.push({ tag: value });
      if (this.updateTagsSub) {
        this.updateTagsSub.unsubscribe();
      }
      this.updateTagsSub = this.patientService.updatePatient(this.patient.id, { tags: this.patientTags, id: this.patient.id })
        .pipe(takeUntil(this.destroy$))
        .subscribe();
    }

    // Clear the input only if the tag is being added from the autocomplete selection
    this.resetTagInput();
  }

  onTagInputTokenEnd(event: MatChipInputEvent): void {
    const value = event.value.trim();
    if (value && !this.autocompleteTrigger.panelOpen) {
      this.addTag(value);
    }
    event.chipInput!.clear();
  }

  removeTag(tag: any): void {
    this.scrollPositionService.saveScrollPosition('patientFile', 'details');
    const index = this.patientTags.findIndex(t => t.tag === tag.tag);
    this.patientTags.splice(index, 1);

    if (this.updateTagsSub) {
      this.updateTagsSub.unsubscribe();
    }
    this.updateTagsSub = this.patientService.updatePatient(this.patient.id, { tags: this.patientTags, id: this.patient.id })
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  updateMenuOptions() {
    // Start with a copy of the original menu options
    this.menuOptions = [...this.originalMenuOptions];
    // Before the `hasHospitals` early return below, deliberately: a group with no hospitals returns
    // there and would otherwise keep the hidden entry.
    if (!this.practiceFormsEnabled) {
      this.menuOptions = this.menuOptions.filter(i => i.text !== 'Send Form');
    }
    if (this.stateMode) {
      const outside = ['Send Form', 'Send Document', 'Add Estimate/Invoice', 'Add Lab Order', 'Add Procedure Code'];
      this.menuOptions = this.menuOptions.filter(i => !outside.includes(i.text));
    }
    if (!this.hasHospitals) { return; }
    if (this.patient && this.patient.status === 'opd') {
      this.menuOptions = this.menuOptions.filter(i => i.text !== 'Discharge Patient');
    } else {
      this.menuOptions = this.menuOptions.filter(i => i.text !== 'Admit Patient');
    }
  }

  scrollTo(elementId: string, scrollToContainerTop: boolean = false): void {
    this.togglePanel(elementId, true);
    setTimeout(() => {
      this.scrollPositionService.scrollTo(elementId, scrollToContainerTop);
    }, 250)
  }

  openWhatsAppDialog(ev: MouseEvent): void {
    ev.preventDefault();
    ev.stopPropagation();
    if (!this.patient?.id) {
      return;
    }

    const dialogRef = this.dialog.open(WhatsAppChatDialogComponent, {
      width: '900px',
      maxWidth: '90vw',
      height: '80vh',
      maxHeight: '90vh',
      data: {
        patientId: this.patient.id,
        patient: this.patient
      }
    });
  }

  /**
   * Handles a click on a tel: link. Mirrors the calendar's virtual-link flow:
   * offers to start an AI recording for the call ("Dial + Record") or just dial
   * ("Dial Only"). Opens the dialer in a new context so the page's unload events
   * are not triggered. If a recording is already locked/in progress we skip the
   * prompt and dial directly to avoid opening a second recording dialog.
   */
  async dialPhone(event: MouseEvent, phoneNumber?: string): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    const number = phoneNumber?.trim();
    if (!number) {
      return;
    }

    const telLink = 'tel:' + number;

    if (this.patient && !this.patientService.isRecordingLocked()) {
      const startRecording = await this.showConfirmationDialog(
        'Start Recording?',
        'You are about to dial this number. Would you like to start an AI-generated recording for the call? Remember to return later to stop the recording once you\'re done.',
        [],
        'Dial Only',
        'Dial + Record'
      );

      if (startRecording) {
        this.openAIDialog(true);
        this.showToastMessage('AI recording is starting. The dialer will open in 2 seconds...');
        // Short delay so the recording can start before the dialer takes focus.
        setTimeout(() => this.openTelLink(telLink), 2000);
        return;
      }
    }

    this.openTelLink(telLink);
  }

  private openTelLink(link: string): void {
    // Open via a temporary anchor (with window.open fallback) so the current
    // document's unload/beforeunload handlers are not triggered.
    try {
      const tempLink = document.createElement('a');
      tempLink.href = link;
      tempLink.target = '_blank';
      tempLink.rel = 'noopener noreferrer';
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    } catch (error) {
      console.warn('Failed to open dialer with temporary element method:', error);
      try {
        window.open(link, '_blank');
      } catch (fallbackError) {
        console.error('All methods to open dialer failed:', fallbackError);
        this.showToastMessage('Please manually dial the number: ' + link.replace('tel:', ''));
      }
    }
  }

  returnToParent() {
    if (this.patientService.isRecordingLocked()) {
      return;
    }
    this.stateCache.set('expandedPanels', this.defaultExpandedPanels);
    this.patientService.setCurrentPatient(null);
    this.patientService.getPatientById(null)
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe();

    const parentPath = parentListPath(this.router.url);

    /*
     * The query string goes back with us. For the Inbox that is `?tab=`, without which returning
     * from a file always landed on New regardless of which tab the file was opened from. Captured
     * BEFORE the first navigate, which drops it.
     */
    const queryParams = { ...this.route.snapshot.queryParams };
    delete (queryParams as any).item;

    this.router.navigate(['/patients', { outlets: { patient: null } }]).then(() => {
      this.router.navigate(['/patients', parentPath], { queryParams });
    });
  }

  colleagueExists(member: any): boolean {
    return this.colleagues?.filter((c: any) => c.email === member.email || c.phone === member.phone).length > 0
  }


  addingColleague: any = {}; // Object to store the new colleague being added
  @ViewChild('addColleagueDialog') addColleagueDialog?: TemplateRef<any>;

  addColleague(member: any) {
    this.addingColleague = { ...member, contactNumber: member.phone };

    let dialogRef = this.dialog.open(this.addColleagueDialog!, { width: '600px' }); // Open the add colleague dialog

    dialogRef.afterClosed().subscribe(colleageDetails => {
      if (colleageDetails) {
        this.colleagueService.addColleague(colleageDetails)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (result) => {
              this.showToastMessage('Physician added to your network successfully');
            },
            error: (error) => {
              console.error('Error adding colleague: ', error);
              this.showToastMessage('There was an error adding the physician to your network. Please try again.');
            }
          });
      }
    })
  }

  navigate = (event: MouseEvent | undefined, type: string) => {
    event?.preventDefault();
    event?.stopPropagation();

    switch (type) {
      case 'ai':
        if (this.aiIsBusy) {
          this.showToastMessage('We are currently processing your AI request. Please wait until this request is complete before submitting a new one.')
          break;
        }
        this.openAIDialog();
        break;
      case 'managePatient':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['edit', this.patient.id],
          }
        }]);
        break;
      case 'admitPatient':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['admit', this.patient.id],
          }
        }]);
        break;
      case 'dischargePatient':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['discharge', this.patient.id],
          }
        }]);
        break;
      case 'manageNote':
        this.patientNotesService.setEditingNote(null);
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-note'],
          }
        }]);
        break;
      case 'manageMorbidityMortality':
        this.patientNotesService.setEditingNote(null);
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-mm'],
          }
        }]);
        break;
      case 'managePrescription':
        this.patientPrescriptionService.setCloning(null);
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-prescription'],
          }
        }]);
        break;
      case 'manageAppointment':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-appointment'],
          }
        }]);
        break;
      /* case 'manageBilling':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-invoicing'],
          }
        }]);
        break; */
      case 'manageConsent':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-consent'],
          }
        }]);
        break;
      // Practice forms (tasks/patient-forms.md 5.2). A dialog, not a route: the send is a
      // three-field ask, and the answers live in the FORMS panel below rather than on a page.
      case 'manageForm':
        if (!this.patient) { break; }
        this.dialog.open(PatientFormSendDialogComponent, {
          width: '520px',
          maxWidth: '95vw',
          data: { patient: this.patient },
        });
        break;
      // Practice documents (tasks/practice-documents.md 7 phase 2). A dialog for the same reason
      // the form send is one: it is a three-field ask, and what comes back lives in the DOCUMENTS
      // panel below rather than on a page.
      case 'manageDocument':
        if (!this.patient) { break; }
        this.dialog.open(PatientDocumentSendDialogComponent, {
          width: '520px',
          maxWidth: '95vw',
          data: { patient: this.patient },
        });
        break;
      case 'manageCoding':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-procedure-code'],
          }
        }]);
        break;
      case 'manageTask':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-task'],
          }
        }]);
        break;
      case 'manageLabOrder':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-lab-order'],
          }
        }]);
        break;
      // N3 — routes now, exactly like its siblings. The shared add dialog stays where it belongs,
      // on the AI-suggestion accept path in `patient-ai-request-detail` / `patient-note-detail`.
      case 'manageRiskItem':
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['add-risk-item'],
          }
        }]);
        break;
      case 'manageFinancials':
        this.openFinanceForm();
        break;
      case 'seedNotes':
        this.patientNotesService.seedSamplePatientNotes(20, this.patient.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe();
        break;
      default:
        console.warn('Unknown navigation type:', type);
        return;
    }

  }

  openAIDialog(startRecording?: boolean) {
    if (!this.patient) return;
    this.patientService.triggerAiRecording.next(false);
    this.idleService.overrideIdleTime(180);
    this.screenWake.disableScreenSleep();

    let dialogRef = this.dialog.open(AiDialogComponent, {
      ...FLOATING_AI_DIALOG_BASE,
      //width: '80vw',
      //height: '85vh',
      disableClose: true,
      panelClass: AI_DIALOG_PANEL_CLASSES,
      data: { patientId: this.patient.id, groupId: this.patient.groupId, startRecording }
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((request) => {
        this.idleService.startIdleChecking();
        this.screenWake.enableScreenSleep();

        if (request) {
          const sub = this.patientAIService.getPatientAIRequestById(request.id)
            .subscribe(() => {
              sub.unsubscribe();
              this.router.navigate(['/patients', {
                outlets: {
                  patient: ['edit-request', request.id],
                }
              }]);
            });

        }
        dialogRef.componentInstance.resetAll();
      });
  }

  async openFinanceForm() {
    await this.checkMedicalAidDetails(true);

    this.dialog.open(DisputeFormComponent, {
      width: '95vw',
      height: '90vh',
      maxWidth: '95vw',
      maxHeight: '95vh',
      data: this.patient, // Pass the patient object
    })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result) => {
          if (result) {
            /* if (result.isActive) {

            } */
            this.showToastMessage('Patient billing created succesfully');
          }
        },
        error: (error) => {
          console.error('Error: ', error);
          //this.showToastMessage('Ooops! There was an error with the billing. Please try again.');
        }
      });

  }


  /** Opens the floating chat window on the practice's chat about this patient. */
  /** The chat window, searched for this patient: their chat, referral chats and patient-app chat to pick from. */
  openPatientChat(): void {
    if (!this.patient) return;
    this.chatService.openPatientSearch(this.patient).catch(() =>
      this.feedbackService.showToast('Chat is not available right now.'));
  }
}
